import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
  showEditor: false,
  currentFile: "",
  newlyCreatedFiles: [], // Track files that need sharing prompts
};

export const myFilesSlice = createSlice({
  name: "myFileSlice",
  initialState,
  reducers: {
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    updateFile: (state, action) => {
      const { url, filePath, id } = action.payload;
      const fileToUpdate = state.files.find(
        (file) => file.filePath === filePath || file.id === id
      );
      if (fileToUpdate) {
        fileToUpdate.url = url;
      }
    },
    addNewlyGeneratedFile: (state, action) => {
      state.files.unshift(action.payload);
      // Also add to newly created files for sharing prompt
      if (!state.newlyCreatedFiles.includes(action.payload.id)) {
        state.newlyCreatedFiles.push(action.payload.id);
      }
    },
    deleteFileInRedux: (state, action) => {
      state.files = state.files.filter((file) => file.id !== action.payload.id);
      // Also remove from newly created files
      state.newlyCreatedFiles = state.newlyCreatedFiles.filter(id => id !== action.payload.id);
    },
    updateFileIsPublicStatus: (state, action) => {
      const { filePath, isPublic } = action.payload;
      const fileToUpdate = state.files.find(
        (file) => file.filePath === filePath
      );
      if (fileToUpdate) {
        fileToUpdate.isPublic = isPublic;
      }
    },
    updateFilePrivacyInRedux: (state, action) => {
      const { id, isPublic } = action.payload;
      const fileToUpdate = state.files.find((file) => file.id === id);
      if (fileToUpdate) {
        fileToUpdate.isPublic = isPublic;
      }
      // Also update currentFile if it's the same file
      if (state.currentFile && (state.currentFile.id === id || state.currentFile.svgMetadataId === id)) {
        state.currentFile = { ...state.currentFile, isPublic };
      }
    },
    markFileAsPromptedForSharing: (state, action) => {
      const fileId = action.payload;
      console.log("🔥 REDUX MYFILES: Marking file as prompted:", fileId);
      console.log("🔥 REDUX MYFILES: newlyCreatedFiles before:", state.newlyCreatedFiles);
      state.newlyCreatedFiles = state.newlyCreatedFiles.filter(id => id !== fileId);
      console.log("🔥 REDUX MYFILES: newlyCreatedFiles after:", state.newlyCreatedFiles);
    },
    setShowEditor: (state, action) => {
      const { showEditor, currentFile } = action.payload;
      state.showEditor = showEditor;
      state.currentFile = currentFile;
    },
    setCurrentFileWorkflow: (state, action) => {
      if (state.currentFile) {
        state.currentFile = { ...state.currentFile, workflow: action.payload };
      }
    },
  },
});

export const {
  setFiles,
  setShowEditor,
  setCurrentFileWorkflow,
  updateFile,
  deleteFileInRedux,
  updateFileIsPublicStatus,
  updateFilePrivacyInRedux,
  addNewlyGeneratedFile,
  markFileAsPromptedForSharing,
} = myFilesSlice.actions;
export default myFilesSlice.reducer;
